import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Programmesleft from './ProgrammesleftEle'
import { Container, Row, Col } from 'react-bootstrap';



function MtechEle() {
  return (
    <section className="project-detail">
      <Container>
        <Row>
          <Col md={4} className='c-left custom-padding-color mb-4'>
              <Programmesleft activeIndex={3} />           
          </Col>

          <Col md={8} className='c-right me-8'>
            <div className="c-heading">
              <h3>Master of Public Policy (MPP) </h3> <br />
            </div>

            <div className="border border-dark">
              <div className="p-3 fw-bold">
                <div id="about">

                  <p className="caboutus">IIIT Tirupati is offering Master of Public Policy (MPP) programme in the Department of Humanities and Social Sciences from the academic year 2022. The current intake is 20.<br /> <br />

                    <span>For admissions related information <Link className='c-link' to="/master-of-public-policy-mpp-admission" target="_blank;">click here</Link>.
                    </span>
                  </p>


                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

    </section>
  );
}

export default MtechEle;
